<template>
  <div
    :class="{
      'margin-small': margin === 'small',
      'margin-medium': margin === 'medium',
      'margin-large': margin === 'large'
    }"
  ></div>
</template>
<script setup lang="ts">
type Props = {
  margin?: 'small' | 'medium' | 'large'
}
defineProps<Props>()
</script>
<style scoped lang="scss">
@use '@/design-system/design-tokens/variables.scss';

div {
  height: 0.1pt;
  background: #e0e0e0;
  width: 100%;
  margin: 0;
}

.margin-small {
  margin: variables.$margin-small 0;
}

.margin-medium {
  margin: variables.$margin-medium 0;
}

.margin-large {
  margin: variables.$margin-large 0;
}
</style>
